module.exports = "<div class=inp-subtle> <span class=inp-subtle-span v-text=\"placeholder+'.'\"></span> <input :id=id v-if=type :type=type v-model=\"fragment['@value']\"> <textarea class=inp-big-focus :id=id v-else v-model=\"fragment['@value']\"></textarea> <input-type :model.sync=\"fragment['@type']\" placeholder=wut @blur=blur></input-type> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValueLiteral.vue
 ** module id = 146
 ** module chunks = 0
 **/